module.exports = __webpack_public_path__ + "img/top.c83bd253.svg";